<template>
    <employment-doc-body
        v-model="form.fields"
        v-bind="{
            mode,
            pages,
        }"
        withoutReset
        @input="emit"
    />
</template>

<script>
import EmploymentDocBody from "@/components/dashboard/common/employment/doc/employment-doc-body.vue";

import { initEmploymentForm } from "@/assets/variables";

export default {
    components: {
        EmploymentDocBody,
    },
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentForm>} */
        value: { type: Object, default: initEmploymentForm },
    },
    data: () => ({
        form: initEmploymentForm(),
    }),
    computed: {
        pages() {
            return this.form?.pages;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style></style>
